// @flow
import AllCompetitionsResults from 'components/competitions/AllCompetitionsResults';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/competitions/AllCompetitionsResults';
import { fetchPageList } from 'actions/pageActions';
import { initialFetchCompetitions, fetchCompetitions } from 'actions/competitionsActions';
import { fetchSeason } from 'actions/seasonsActions';
import { InitialFetchRencontreByFilters, fetchRencontreByFilters } from 'actions/rencontreActions';
import { fetchTeamList } from 'actions/teamlistActions';

export default connect(
  (state: StateType): StateProps => ({
    title: state.pageListState.title,
    excerpt: state.pageListState.excerpt,
    featured_media: state.pageListState.featured_media,
    meta_title: state.pageListState.meta_title,
    meta_description: state.pageListState.meta_description,
    sidebar_content: state.pageListState.sidebar_content,
    status: state.pageListState.status,
    competitions: state.competitionsState.competitions,
    seasons: state.seasonsState.seasons,
    currentSeasonId: state.settingsState.saison_en_cours,
    rencontres: state.rencontreState.rencontres,
    rencontresFetchStatus: state.rencontreState.status,
    defaultSeason: state.filterOptionsState.defaultSeason,
    teamlist: state.teamlistState.teamlist,
    redirect_competitions: state.pageListState.redirect_competitions,
    redirect_resultats: state.pageListState.redirect_resultats
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchPageList: (slug: string) => dispatch(fetchPageList(slug)),
    initialFetchCompetitions: (filters: Object) => dispatch(initialFetchCompetitions(filters)),
    InitialFetchRencontreByFilters: (filters: Object) => dispatch(InitialFetchRencontreByFilters(filters)),
    fetchRencontreByFilters: (filters: Object) => dispatch(fetchRencontreByFilters(filters)),
    fetchCompetitions: (filters: Object) => dispatch(fetchCompetitions(filters)),
    fetchSeason: () => dispatch(fetchSeason()),
    fetchTeamList: () => dispatch(fetchTeamList())
  })
)(AllCompetitionsResults);
